import KC_Heading2 from "../../designsystem/typography/KC-Heading/KC_Heading2";
import { tt } from "../../utils/i18n/i18n";
import React, { useState } from "react";
import KC_Tabs, { type KC_TabItem } from "../../designsystem/KC_Tabs/KC_Tabs";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import "./Legal.scss";
import KC_Button from "../../designsystem/KC_Button/KC_Button";
import KC_UIText from "../../designsystem/typography/KC_UIText/KC_UIText";

type TabType = "dpa" | "terms";

export default function () {
  const [activeTab, setActiveTab] = useState<TabType>("dpa");

  const tabItems: KC_TabItem[] = [
    {
      name: tt("data_protection_agreement"),
      value: "dpa"
    },
    {
      name: tt("terms_of_sale"),
      value: "terms"
    }
  ];

  const handleTabSelect = (value: string) => {
    setActiveTab(value as TabType);
  };

  const getCurrentPdfUrl = () => {
    const baseUrl = activeTab === "dpa" ? tt("dpaURL") : tt("terms_link");
    // Add PDF viewer parameters to hide toolbar and navigation panes by default
    return `${baseUrl}#toolbar=0&navpanes=0&view=FitH`;
  };

  const getCurrentTitle = () => {
    return activeTab === "dpa"
      ? tt("data_protection_agreement")
      : tt("terms_of_sale");
  };

  return (
    <div className="legal-page d-flex flex-column dashboard-v2 page-padding-standard">
      <div className="d-flex flex-column mb-3 mb-md-4">
        <KC_Heading2 text={tt("legal")} />
      </div>

      <div className="mt-2 mt-md-4">
        <KC_Tabs
          items={tabItems}
          onSelect={handleTabSelect}
          initialSelectedIndex={0}
          id="legal-tabs"
        />
        <div className="d-block d-sm-none mt-4">
          <KC_UIText weight="reg" text={tt("pdf_mobile_explanation")} />
        </div>
        <div
          className="d-block d-sm-none position-fixed w-100 p-3"
          style={{
            bottom: 0,
            left: 0,
            right: 0
          }}
        >
          <KC_Button
            isPrimary={true}
            showIconOnTheRight={true}
            icon={faExternalLinkAlt}
            text={tt("open_pdf")}
            onClick={() => {
              window.open(getCurrentPdfUrl(), "_blank");
            }}
          />
        </div>

        <div className="legal-page__pdf-container mt-3 mt-md-4">
          <div className="d-none d-md-block w-100">
            {activeTab === "dpa" && (
              <iframe
                src={tt("dpaURL")}
                title={tt("data_protection_agreement")}
                className="d-block w-100"
              />
            )}
            {activeTab === "terms" && (
              <iframe
                src={tt("terms_link")}
                title={tt("terms_of_sale")}
                className="d-block w-100"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
